import React from 'react';
import './News.css';

const News = () => {
    return (
        <div className="news">
            <div>
                <h2>Daily 10 image/photos Download</h2>
                <p><small>Top website templates with the highest sales volume.</small></p>
                <button className="twin-btn">Get Started</button>
            </div>
        </div>
    );
};

export default News;